export const getFormBaseValidationRule = () => {
  return {
    DEFAULT: {
      DO_NOT_VALIDATE: {},
      VALIDATION_RULE: { required: true },
      VALIDATION_RULE_MESSAGE: { required: 'This is required field.' },
    },
    EMAIL: {
      VALIDATION_RULE: {
        required: true,
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: 'Invalid email format.',
        },
      },
    },
    MULTI_SELECT: {
      // use validate instead of required because RHF treats [] as truthy
      VALIDATION_RULE: {
        validate: (v) => (Array.isArray(v) && v.length > 0) || 'This is required field.',
      },
    },
  };
};